import { Storage } from "lib/storage";
import { captureDB } from "lib/indexed-db";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "types";

export function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    Storage.clear();
    window.sessionStorage.clear();
    captureDB.clearAllData(); // Clear IndexedDB on logout
    navigate(AppRoutes.home, { replace: true });
    window.location.reload();
  }, [navigate]);

  return null;
}
